import { render, staticRenderFns } from "./pictureComponent.vue?vue&type=template&id=9b03631c&scoped=true"
import script from "./pictureComponent.vue?vue&type=script&lang=js"
export * from "./pictureComponent.vue?vue&type=script&lang=js"
import style0 from "./pictureComponent.vue?vue&type=style&index=0&id=9b03631c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b03631c",
  null
  
)

export default component.exports